import React from 'react'
import { Link } from 'react-router-dom'
const MainContent = () => {
    return (
        <>
            <div className="bread-internal-cls">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/services">Services</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Web Development
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <section className="services-details-area ptb-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 services-details">
                            <div className="ml-about-content">
                                <h1>Best Web Development company in Noida</h1>
                                <div className="bar" />
                            </div>
                            <p className="mb-3">
                                Alobha Technologies, <b>Web Development Company in Noida</b>, offers world class interactive website design services to give your business a significant boost and help you forge ahead in a highly competitive
                                world. Our expert programmers use diverse open source as well as
                                closed source technologies to create agile, responsive, feature
                                rich, interactive websites that become a platform for interaction
                                with customers, buyers and between staff, helping you boost
                                efficiencies and increase productivity as well as enhance your
                                image.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-12 services-details">
                        <div className="services-details-desc">
                            {/* Changed to h2 tag after SEO with Zikran  ---> Initially it was h3 */}
                            <h2>
                                <b>Our Website design and Development Process Follows these Steps</b>
                            </h2>
                            <p>
                               <b> Website design and development</b> process consists of seven continuous steps that meet the needs of our satisfied customers every year. These steps are:
                            </p>
                            <ul className="text_color">
                                <li>
                                    <b>Analysis: </b> Our <b>Website Development</b> experts analyze online consumer behavior for your target market, the technical construction of the World Wide Web and verify how relevant your domain information is to your web marketing needs.
                                </li>
                                <li>
                                    <b> Strategy:</b> Our <b>Web Development</b> expert will organize and evaluate your information and develop a web strategy that matches your online marketing plan.
                                </li>
                                <li>
                                    <b> Architecture:</b> Our <b>web development agency</b> professionals will design a website blue-print for structure, layout, back end systems and functionality.
                                </li>
                                <li>
                                    <b> Creation:</b> Web developers use technical programming
                                    languages and HTML tools, alongside other IT to develop your new
                                    site.
                                </li>
                                <li>
                                    <b> Implementation:</b> Our experts will configure your website to
                                    our advanced, secure environment and ensure the site is linked to
                                    the domain information.
                                </li>
                                <li>
                                    <b> Positioning:</b> Alobha specialized Web Magnet technology is
                                    used to place the website in major search engines such as Google
                                    to ensure your business gains maximum exposure to your target
                                    market.
                                </li>
                                <li>
                                    <b> Monitoring:</b> As well as developing the site, our internet
                                    experts will monitor your website and the web environment,
                                    ensuring correct parameters.
                                </li>
                            </ul>
                            <p>
                                A great site is not measured by looks alone; real success is
                                delivering something secure, dependable and easy for users to
                                navigate.
                            </p>
                            <p>
                                Alobha Technologies, a leading <b>web development company in Delhi NCR</b>, has a full in-house web development team and over years of experience in <b>Website design and development</b> of websites. We have successfully delivered hundreds of websites, critical web applications, ecommerce websites and social media platforms.
                            </p>
                            <p className="mb-3">
                                We expect a lot from of our web developers and so do our clients.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc">
                                <h3>
                                    <b>Our websites are:</b>
                                </h3>
                                <ul className="text_color" style={{marginLeft:"20px"}}>
                                    <li>Fast</li>
                                    <li>User Friendly</li>
                                    <li>Mobile (responsive)</li>
                                    <li>Search Engine Optimized</li>
                                    <li>Accessible</li>
                                </ul>
                            </div>
                            <div className="services-details-desc">
                                <h3>
                                    <b>
                                        As Web Development company in Noida, our Web Development
                                        services include:
                                    </b>
                                </h3>
                                <ul className="text_color" style={{marginLeft:"20px"}}>
                                    <li>Optimized HTML 5 &amp; CSS 3</li>
                                    <li>Responsive Websites</li>
                                    <li>JQuery &amp; Ajax</li>
                                    <li>CMS Development</li>
                                    <li>PHP and MySQL development</li>
                                </ul>
                                <p className="mb-3">
                                    We love open source web development technologies because it allows
                                    us to deliver impressive solutions to cost-effective budgets.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc">
                                <h3>
                                    <b>Mobile, tablet and desktop responsive websites </b>
                                </h3>
                                <p>
                                    "We use Responsive web design techniques so that our websites work
                                    for all customers, no matter which device or platform they are
                                    using."
                                </p>
                                {/* <h3>
                                    A Web development Company, that meets the needs of your business!
                                </h3> */}
                                <h4 style={{ fontSize: "20px", marginBottom: "15px" }}></h4>
                                <p>
                                    Our idea of professional <b>website development</b> is ensuring that you have a consistent and productive development environment. There is no need to waste time and money searching for staff to fulfill your need for professional development of websites. Let our team be your team.
                                </p>
                                <p>
                                    Have any questions regarding our <b>web development services</b> or
                                    looking for a proposal for your next web development project?{" "}
                                    <a href="/contact">Contact Us!</a>
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details">
                            <div className="ml-about-content">
                                <h2>Php Website Development company</h2>
                                <div className="bar" />
                                <p>
                                    We are providing fresh, creative digital services to our clients
                                    to help them taking their online digital presence to new heights.
                                    We don’t just do web design but we develop creative, user friendly
                                    and feature rich web applications. Our PHP Web Development team
                                    has rich experience which helps us in designing beautiful websites
                                    which are also outstanding and easily scalable. We make sure our
                                    visual solutions are innovative, fresh and technically sound. We
                                    ask our clients to trust us to create an exceptional online
                                    identity for their business and brand.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details-image">
                            <img loading="lazy"
                                src="assets/img/service-detail-image/1.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                    </div>

                    <div className="separate">
                        <div className="row align-items-center mb-4">
                            <div className="col-lg-6 col-md-6 services-details-image">
                                <img loading="lazy"
                                    src="assets/img/service-detail-image/2.webp"
                                    className="wow fadeInUp"
                                    alt=""
                                />
                            </div>
                            <div className="col-lg-6 col-md-6 services-details">
                                <div className="ml-about-content">
                                    <h2>Laravel Website Development company</h2>
                                    <div className="bar" />
                                    <p>
                                        <a
                                            href="https://alobhatechnologies.com/contact.html"
                                            className="inner-link"
                                        >
                                            <b>Website Development</b>
                                        </a>{" "}
                                        is one of the fastest growing domains in IT industry. Alobha Technology is one of the best Laravel <b>Web Development Company in India</b> specialized in providing on demand striking web application development. We take our pride of being able to accommodate highly
                                        experienced Laravel Developers those have mastered their field of
                                        work, which have made us “A suitable choice for anyone looking for a
                                        Laravel development company or a laravel developer in India to
                                        outsource” to quote one of our clients.We adhere to the coding
                                        guidelines and standards for developing any kind of website or
                                        applications.
                                    </p>
                                    {/* <div className="services-details-accordion">
                                        <ul className="accordion">
                                            <li className="accordion-item">
                                                <a className="accordion-title" >
                                                    Which material types can you work with?
                                                </a>
                                            </li>
                                            <li className="accordion-item">
                                                <a className="accordion-title" >
                                                    Is Smart Lock required for instant apps?
                                                </a>
                                            </li>
                                            <li className="accordion-item">
                                                <a className="accordion-title" >
                                                    Can I have multiple activities in a single feature?
                                                </a>
                                            </li>
                                        </ul>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MainContent